import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';
import { IDocumentActionUserDecisionResult } from '@/models/document-actions.model';

export const documentAcquaintsService = {
  userDecision,
  ValidateSign
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'DocumentAcquaints'
};

function extract(r: any) {
  return r.data;
}

async function userDecision(documentAcquaintUserId: number, documentAcquaintUserStatusId: number): Promise<IDocumentActionUserDecisionResult> {
  return axios
    .patch(`${model.baseUrl}${model.controller}/users`, { documentAcquaintUserId, documentAcquaintUserStatusId })
    .then(extract);
}

async function ValidateSign(documentAcquaintUserSignsId: number, documentAccessToken: string = '') {
  let url = `${model.baseUrl}${model.controller}/ValidateSign`;
  url = `${url}?documentAcquaintUserSignsId=${documentAcquaintUserSignsId}`;
  url = `${url}&documentAccessToken=${documentAccessToken}`;
  return axios.get(url).then(extract);
}
